import type {ReactElement} from 'react';
import {useContext} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {getResolvedTiles} from '@EmailMakerReact/lib/email-maker-tile-meta-library';
import {ControlTile} from '../control-tile/control-tile';
import {ActionStrip} from '../action-strip/action-strip';
import type {TileListProps} from './tile-list.types';
import styles from './tile-list.module.scss';

export function TileList({selected, onTileSelect}: TileListProps): ReactElement {
  const {editor, store} = useContext(emailMakerContext);
  const controlTiles = selected && editor ? getResolvedTiles(editor, selected, store) : [];

  return (
    <div className={styles.list} role="toolbar" aria-label={window.i18next.t('pmwjs_email_maker_bottom_bar_controls_aria')}>
      {controlTiles.map((entry) => (
        <ControlTile key={entry.flatIndex} entry={entry} onTileSelect={onTileSelect} />
      ))}
      <ActionStrip />
    </div>
  );
}
